'use client';
import dynamic from 'next/dynamic';
import {PriceHistoryEntry} from "@/types";

// Lazy-load VariantPriceChart to defer recharts (~150KB) until needed
const VariantPriceChartLazy = dynamic(
    () => import('./variant-price-chart').then(mod => ({default: mod.VariantPriceChart})),
    {
        ssr: false,
        loading: () => (
            <div className="w-full mx-auto overflow-hidden border rounded-lg">
                <div className="p-6 pb-2">
                    <div className="flex items-center justify-between">
                        <div className="h-6 w-40 bg-gray-200 rounded animate-pulse" />
                        <div className="h-8 w-24 bg-gray-200 rounded animate-pulse" />
                    </div>
                    <div className="h-4 w-64 bg-gray-200 rounded animate-pulse mt-2" />
                </div>
                <div className="h-52 bg-gray-100 animate-pulse mx-4" />
                <div className="p-6 flex justify-center">
                    <div className="h-9 w-72 bg-gray-200 rounded animate-pulse" />
                </div>
            </div>
        )
    }
);

interface PriceTrend {
    trend: "up" | "down" | "stable";
    percentage: number;
}

export const VariantPriceChartDynamic = ({
    priceHistory,
    priceTrend
}: {
    priceHistory: PriceHistoryEntry[];
    priceTrend: PriceTrend;
}) => {
    return <VariantPriceChartLazy priceHistory={priceHistory} priceTrend={priceTrend} />;
};
